import { useMediaQuery, useTheme } from '@mui/material';
import Link from 'next/link';
import React from 'react';

const categories = [
	{
		categoryId: '6519604594c1b61a4d62db60',
		title: 'APPAREL',
		bgColor: '#FFCC00',
		color: '#000000',
		slug: 'apparel',
	},
	{
		categoryId: '6519604594c1b61a4d62db66',
		title: 'BEAUTY',
		bgColor: '#B332E6',
		color: '#ffffff',
		slug: 'beauty',
	},
	{
		categoryId: '6519604594c1b61a4d62db6c',
		title: 'FOOTWEAR',
		bgColor: '#00BFFF',
		color: '#000000',
		slug: 'footwear',
	},
	{
		categoryId: '6519604594c1b61a4d62db6b',
		title: 'FOOD',
		bgColor: '#9C6',
		color: '#000000',
		slug: 'food-and-drink',
	},
	{
		categoryId: '6519604594c1b61a4d62db6e',
		title: 'HOME',
		bgColor: '#B332E6',
		color: '#ffffff',
		slug: 'home',
	},
];

const CategoryCards = () => {
	const theme = useTheme();
	const isXl = useMediaQuery(theme.breakpoints.down('xl'));
	const isLg = useMediaQuery(theme.breakpoints.down('lg'));
	const isMd = useMediaQuery(theme.breakpoints.down('md'));
	const isSm = useMediaQuery(theme.breakpoints.down('sm'));
	const isXs = useMediaQuery(theme.breakpoints.down('xs'));

	const getCategoriesToRender = () => {
		if (isMd || isSm || isXs) return categories;
		else if (isLg) return categories.slice(0, 3);
		else if (isXl) return categories.slice(0, 4);
		return categories;
	};

	return (
		<div
			className={`flex gap-2 ${
				isMd ? 'flex-nowrap overflow-auto' : 'justify-center'
			}`}
		>
			{getCategoriesToRender().map((cat, i) => {
				return (
					<div
						key={cat?.categoryId || i}
						className='flex-grow-0 flex-shrink-0 basis-auto md:flex-grow md:basis-0 w-1/2 mb-2'
					>
						<Link
							href={`/categories/${cat?.slug}`}
							style={{ all: 'unset' }}
						>
							<div
								style={{
									cursor: 'pointer',
									borderRadius: '10px',
									backgroundColor: cat.bgColor,
									color: cat.color,
									textAlign: 'center',
									fontSize: '24px',
									fontWeight: 700,
									padding: '17px 15px',
								}}
							>
								{cat.title}
							</div>
						</Link>
					</div>
				);
			})}
		</div>
	);
};

export default CategoryCards;
